// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3R2DO","clinicsSelect":"TableHeading_clinicsSelect__2Hj5q"};